export default __webpack_public_path__ + "static/media/iconDownload.e6f594bd.svg";